import { CONSTANTS } from "src/constants";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import {
  ApContactData,
  ContactData,
  EmailData,
  SwitchContactData,
} from "src/models/contact.models";
import commonUtils from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function addContactOffice(uuid: string, payload: ContactData) {
  const url = commonUtils.getUrlReplace(
    API_URL.CONTACT_VIEW.ADD_CONTACT_OFFICE,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  return await apiCall.post(url, payload);
}

export async function editEmail(uuid: string, payload: EmailData) {
  const url = commonUtils.getUrlReplace(
    API_URL.CONTACT_VIEW.EDIT_EMAIL,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}

export async function getContactTitle(type?: string) {
  if (type) {
    return await apiCall.get(API_URL.CONTACT_VIEW.GET_TITLE_WITH_TYPE + type);
  }
  return await apiCall.get(API_URL.CONTACT_VIEW.GET_TITLE);
}

export async function getOfficeContactView(uuid: string) {
  const url = commonUtils.getUrlReplace(
    API_URL.CONTACT_VIEW.GET_CONTACT_VIEW,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  return await apiCall.get(url);
}

export async function getFullContactPermission(uuid: string, type?: number) {
  const url = commonUtils.getUrlReplace(
    API_URL.CONTACT_VIEW.GET_FULL_CONTACT,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  return await apiCall.get(url, { type: type ?? 1 });
}

export const removeContact = async (
  officeUuid: string,
  contactUuid: string
) => {
  const url = API_URL.CONTACT_VIEW.REMOVE_CONTACT.replace(
    "officeUuid",
    officeUuid
  )
    .replace("contactUuid", contactUuid)
    .replace(/[{}]/g, "");

  return await apiCall.patch(url);
};

export async function switchPrimaryContacts(
  uuid: string,
  payload: SwitchContactData
) {
  const url = commonUtils.getUrlReplace(
    API_URL.CONTACT_VIEW.SWITCH_CONTACT,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}

export async function switchAPContacts(
  uuid: string,
  payload: SwitchContactData
) {
  const url = commonUtils.getUrlReplace(
    API_URL.CONTACT_VIEW.SWITCH_AP_CONTACT,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}

export const updateContactOffice = async (
  officeUuid: string,
  contactUuid: string,
  payload: ContactData
) => {
  const url = API_URL.CONTACT_VIEW.UPDATE_OFFICE.replace(
    "officeUuid",
    officeUuid
  )
    .replace("contactUuid", contactUuid)
    .replace(/[{}]/g, "");

  return await apiCall.patch(url, payload);
};

export async function updateContactActivity(body: {
  activity_status: number | boolean;
  contact_uuid: string;
}) {
  return await apiCall.patch(
    API_URL.CONTACT_VIEW.UPDATE_CONTACT_ACTIVITY_STATUS,
    body
  );
}
export async function findContacts(
  uuid: string,
  search: string,
  userType?: number,
  include_delete?: number
) {
  const isProspect = userType === CONSTANTS.USER.PROSPECT;

  const url = commonUtils.getUrlReplace(
    isProspect
      ? API_URL.PROSPECT.GET_CONTACT_FIND
      : API_URL.CONTACT_VIEW.GET_CONTACT_FIND,
    isProspect ? COMMON_CONSTANTS.PROSPECT_UUID : COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );

  const params: { include_delete?: number; search: string } = { search };

  if (include_delete !== undefined) {
    params.include_delete = include_delete;
  }

  return apiCall.get(url, params);
}

export async function addApContactOffice(
  officeUuid: string,
  payload: ApContactData
) {
  const url = commonUtils.getUrlReplace(
    API_URL.CONTACT_VIEW.ADD_AP_CONTACT,
    COMMON_CONSTANTS.OFFICE_UUID,
    officeUuid
  );
  return await apiCall.post(url, payload);
}
